export default {
      id: "ic_x-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic_x-usage",
      toString: function () {
        return this.url;
      }
    }